import { Link } from 'react-router-dom';
import { pricingPlans } from '@/mocks/home';

export default function Pricing() {
  return (
    <section id="pricing" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-6xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold">
            价格方案
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            从免费开始，按需升级
          </h2>
          <p className="mt-4 text-foreground-600 leading-relaxed">
            个人站长免费使用，团队与代理机构可按需选择更高阶的方案。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          {pricingPlans.map((p) => (
            <div
              key={p.name}
              className={`relative flex flex-col rounded-lg border p-8 ${
                p.highlight
                  ? 'border-primary-500 bg-background-50'
                  : 'border-background-200 bg-background-50'
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  最受欢迎
                </span>
              )}
              <h3 className="font-heading text-xl font-semibold text-foreground-950">{p.name}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
              <div className="mt-6 flex items-end gap-1">
                <span className="font-heading text-4xl font-bold text-foreground-950">
                  ¥{p.price}
                </span>
                <span className="pb-1 text-sm text-foreground-500">{p.period}</span>
              </div>
              <ul className="mt-6 flex flex-col gap-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mt-0.5">
                      <i className="ri-check-line text-xs" />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              {p.cta === '联系我们' ? (
                <a
                  href="mailto:hello@statflow.example.com"
                  className="mt-8 block text-center px-6 py-3 text-sm font-semibold rounded-md transition-colors whitespace-nowrap border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700"
                >
                  {p.cta}
                </a>
              ) : (
                <Link
                  to="/register"
                  className={`mt-8 block text-center px-6 py-3 text-sm font-semibold rounded-md transition-colors whitespace-nowrap ${
                    p.highlight
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700'
                  }`}
                >
                  {p.cta}
                </Link>
              )}
            </div>
          ))}
        </div>
        <p className="mt-8 text-center text-xs text-foreground-500">
          价格为产品规划展示，当前版本未开通在线支付，注册后即可使用全部统计功能。
        </p>
      </div>
    </section>
  );
}